import React from "react";
const NotFound: React.FC = (props: any) => {
  return <div style={{ height: "100vh", width: "100%" }}>Not Found</div>;
};

export default NotFound;
